import React from 'react';
import { Target, Heart, ShieldCheck } from 'lucide-react';
import { motion } from 'framer-motion';
const About = () => {
  const cardVariants = {
    hidden: {
      opacity: 0,
      y: 20
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6
      }
    }
  };
  return <section id="nosotros" className="py-20 md:py-32 bg-benefika-light" data-id="element-15">
      <div className="container mx-auto px-4" data-id="element-16">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-20" data-id="element-17">
          <h2 className="text-3xl md:text-5xl font-bold text-benefika-charcoal mb-6 tracking-tight" data-id="element-18">
            Sobre Nosotros
          </h2>
          <p className="text-lg text-benefika-gray max-w-3xl mx-auto leading-relaxed" data-id="element-19">
            En Benefika nos especializamos exclusivamente en crear, gestionar y
            potenciar soluciones que fortalecen la relación a largo plazo entre
            las empresas, organizaciones o instituciones y sus clientes,
            usuarios o grupos relacionados.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-20" data-id="element-20">
          <motion.div variants={cardVariants} initial="hidden" whileInView="visible" viewport={{
          once: true
        }} className="bg-white p-10 rounded-2xl shadow-sm border border-gray-100 text-center hover:-translate-y-2 transition-transform duration-300" data-id="element-21">
            <div className="w-16 h-16 bg-benefika-teal/10 rounded-full flex items-center justify-center mx-auto mb-6" data-id="element-22">
              <Target className="text-benefika-teal w-8 h-8" data-id="element-23" />
            </div>
            <h3 className="text-xl font-bold text-benefika-charcoal mb-4" data-id="element-24">
              Nuestra Misión
            </h3>
            <p className="text-benefika-gray leading-relaxed" data-id="element-25">
              Proporcionar soluciones innovadoras de fidelización que generen
              valor real y tangible tanto para nuestros clientes corporativos
              como para sus usuarios finales.
            </p>
          </motion.div>

          <motion.div variants={cardVariants} initial="hidden" whileInView="visible" viewport={{
          once: true
        }} transition={{
          delay: 0.2
        }} className="bg-white p-10 rounded-2xl shadow-sm border border-gray-100 text-center hover:-translate-y-2 transition-transform duration-300" data-id="element-26">
            <div className="w-16 h-16 bg-benefika-amber/10 rounded-full flex items-center justify-center mx-auto mb-6" data-id="element-27">
              <Heart className="text-benefika-amber w-8 h-8" data-id="element-28" />
            </div>
            <h3 className="text-xl font-bold text-benefika-charcoal mb-4" data-id="element-29">
              Nuestra Visión
            </h3>
            <p className="text-benefika-gray leading-relaxed" data-id="element-30">
              Ser el referente principal en la creación de ecosistemas de
              beneficios que transformen transacciones cotidianas en relaciones
              de lealtad duraderas.
            </p>
          </motion.div>

          <motion.div variants={cardVariants} initial="hidden" whileInView="visible" viewport={{
          once: true
        }} transition={{
          delay: 0.4
        }} className="bg-white p-10 rounded-2xl shadow-sm border border-gray-100 text-center hover:-translate-y-2 transition-transform duration-300" data-id="element-31">
            <div className="w-16 h-16 bg-benefika-emerald/10 rounded-full flex items-center justify-center mx-auto mb-6" data-id="element-32">
              <ShieldCheck className="text-benefika-emerald w-8 h-8" data-id="element-33" />
            </div>
            <h3 className="text-xl font-bold text-benefika-charcoal mb-4" data-id="element-34">
              Nuestros Valores
            </h3>
            <p className="text-benefika-gray leading-relaxed" data-id="element-35">
              Innovación constante, compromiso absoluto con los resultados,
              transparencia en la gestión y una profunda orientación hacia la
              experiencia del usuario.
            </p>
          </motion.div>
        </div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.7
      }} className="bg-white p-10 md:p-16 rounded-3xl shadow-lg border border-gray-100 relative overflow-hidden" data-id="element-36">
          {/* Decorative background */}
          <div className="absolute top-0 right-0 w-64 h-64 bg-benefika-teal/5 rounded-full blur-3xl -translate-y-1/2 translate-x-1/3" data-id="element-37"></div>

          <div className="flex flex-col md:flex-row items-center gap-12 relative z-10" data-id="element-38">
            <div className="md:w-1/2" data-id="element-39">
              <span className="text-benefika-teal font-bold tracking-wider uppercase text-sm mb-2 block" data-id="element-40">
                Nuestra Historia
              </span>
              <h3 className="text-3xl md:text-4xl font-bold text-benefika-charcoal mb-6 leading-tight" data-id="element-41">
                El ADN de TicketMaestro, enfocado en la lealtad
              </h3>
              <p className="text-benefika-gray mb-6 leading-relaxed text-lg" data-id="element-42">
                Benefika nació como una evolución natural dentro del ecosistema
                de TicketMaestro. Al gestionar millones de interacciones y
                transacciones, identificamos una necesidad crucial en el
                mercado: las empresas necesitaban ir más allá de la venta
                puntual.
              </p>
              <p className="text-benefika-gray leading-relaxed text-lg" data-id="element-43">
                Hoy, como una marca especializada, combinamos la robustez
                tecnológica y operativa de TicketMaestro con estrategias
                avanzadas de retención, creando programas de beneficios que
                realmente conectan marcas con personas.
              </p>
            </div>
            <div className="md:w-1/2 w-full flex items-center justify-center" data-id="element-44">
              <div className="bg-white rounded-2xl shadow-2xl p-12 transform rotate-2 hover:rotate-0 transition-transform duration-500" data-id="element-45">
                <img src="https://cdn.magicpatterns.com/uploads/kEmr54igVrcYGzG54WYpJH/logo_ticketmaestro_positivo.png" alt="TicketMaestro" className="w-full h-auto max-w-md" data-id="element-46" />
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
};
export default About;